export default __webpack_public_path__ + "static/media/electric-boiler-gray.a17c021f.svg";